export default "__VITE_ASSET__C4zR2GZR__"